export function isInScrollData() {
  const allScrollData =
    typeof window === 'undefined'
      ? {}
      : JSON.parse(sessionStorage.getItem('tsr-scroll-restoration-v1_3') || '{}');
  const key = typeof window === 'undefined' ? '' : window.history.state.key;
  const scrollData = allScrollData[key];
  return !!scrollData;
}
